import { render, staticRenderFns } from "./bookItem.vue?vue&type=template&id=036154b5&scoped=true"
import script from "./bookItem.vue?vue&type=script&lang=js"
export * from "./bookItem.vue?vue&type=script&lang=js"
import style0 from "./bookItem.vue?vue&type=style&index=0&id=036154b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036154b5",
  null
  
)

export default component.exports